import React, { useEffect, useState } from "react";
import LinkInfo from "../../../components/Links/LinkInfo";
import LinksFilterTabs from "../../../components/Links/Sub/LinksFilterTabs";
import { ALL_LINKS_URL } from "../../../constants/ApiUrls";
import GridView from "../../../components/Links/LinksGridView";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";
import GridActions from "../../../components/Links/GridActions";

const ClientLinks = () => {
  const [filter, setFilter] = useState("All");
  const [links, setLinks] = useState();
  const [activeLinks, setActiveLinks] = useState();
  const [disableLinks, setDisableLinks] = useState();
  const [selectedLinkSIndex, setSelectedLinkSIndex] = useState();
  const [selectedLink, setSelectedLink] = useState();
  const [getLinksIfDataUpdates, setGetLinksIfDataUpdates] = useState(false);
  const [sortBy, setSortBy] = useState("clicks");
  const [orderDirection, setOrderDirection] = useState("desc");

  const { auth } = useAuth();
  useEffect(() => {
    document.title = "Snilink - Links";
  }, []);
  useEffect(() => {
    setSelectedLink(
      links && links.find((link) => link.shorten === selectedLinkSIndex)
    );
  }, [selectedLinkSIndex]);
  useEffect(() => {
    getLinks();
  }, [auth, getLinksIfDataUpdates]);
  useEffect(() => {
    if (!links) return;
    const sortedLinks = [...links];
    if (sortBy === "date") {
      sortedLinks.sort((a, b) =>
        orderDirection === "asc"
          ? new Date(a.dateCreated) - new Date(b.dateCreated)
          : new Date(b.dateCreated) - new Date(a.dateCreated)
      );
    } else if (sortBy === "clicks") {
      sortedLinks.sort((a, b) =>
        orderDirection === "asc" ? a.clicks - b.clicks : b.clicks - a.clicks
      );
    } else if (sortBy === "title") {
      sortedLinks.sort((a, b) =>
        orderDirection === "asc"
          ? a.title.localeCompare(b.title)
          : b.title.localeCompare(a.title)
      );
    }
    setLinks(sortedLinks);
    setActiveLinks(sortedLinks.filter((item) => item.status === "active"));
    setSelectedLink(sortedLinks[0]);
    setDisableLinks(sortedLinks.filter((item) => item.status === "disable"));
    setSelectedLinkSIndex(links[0].shorten);
  }, [sortBy, orderDirection]);
  const getLinks = async () => {
    try {
      const response = await axios.get(ALL_LINKS_URL, {
        params: { userId: auth.userId },
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      if (!response.data || response.data.length === 0) return;
      const sortedLinks = [...response.data];
      if (sortBy === "date") {
        sortedLinks.sort((a, b) =>
          orderDirection === "asc"
            ? new Date(a.dateCreated) - new Date(b.dateCreated)
            : new Date(b.dateCreated) - new Date(a.dateCreated)
        );
      } else if (sortBy === "clicks") {
        sortedLinks.sort((a, b) =>
          orderDirection === "asc" ? a.clicks - b.clicks : b.clicks - a.clicks
        );
      } else if (sortBy === "title") {
        sortedLinks.sort((a, b) =>
          orderDirection === "asc"
            ? a.title.localeCompare(b.title)
            : b.title.localeCompare(a.title)
        );
      }
      setLinks(sortedLinks);
      setActiveLinks(sortedLinks.filter((item) => item.status === "active"));
      setSelectedLink(sortedLinks[0]);
      setDisableLinks(sortedLinks.filter((item) => item.status === "disable"));
      setSelectedLinkSIndex(sortedLinks[0].shorten);
    } catch (err) {}
  };

  return (
    <>
      <h1 className="text-primary-900 dark:text-primary-200 md:text-2xl text-xl font-semibold mb-1">
        Links
      </h1>
      {links && (
        <LinkInfo
          setGetLinksIfDataUpdates={setGetLinksIfDataUpdates}
          getLinksIfDataUpdates={getLinksIfDataUpdates}
          link={selectedLink}
        />
      )}
      <LinksFilterTabs
        all={links?.length}
        a={activeLinks?.length}
        d={disableLinks?.length}
        active={filter}
        setActiveTab={setFilter}
      />
      <GridActions
        orderDirection={orderDirection}
        setOrderDirection={setOrderDirection}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />
      <GridView
        filter={filter}
        selectedLinkSIndex={selectedLinkSIndex}
        setSelectedLinkSIndex={setSelectedLinkSIndex}
        links={
          filter == "All"
            ? links
            : filter == "Active"
            ? activeLinks
            : disableLinks
        }
      />
    </>
  );
};
export default ClientLinks;
